import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-attach-proof-operation',
  templateUrl: './attach-proof-operation.component.html',
  styleUrls: ['./attach-proof-operation.component.scss'],
})
export class AttachProofOperationComponent implements OnInit {
  sendButton = false;
  boobleModalData: any;
  proofOperationFile: File;
  loading: boolean;
  private readonly notifier: NotifierService;
  private destroy$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private modalService: BoobleModalService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "false")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.loading = false;
            this.boobleModalData = result.data;
          },
          error: (err) => {
            this.loading = false;
          },
        });
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  uploadDocumentsFile(event: Event) {
    const element = event.target as HTMLInputElement;
    const fileList: FileList | null = element.files;
    if (fileList) {
      this.proofOperationFile = fileList.item(0);
      this.sendButton = true;
    }
  }

  settlementConfirm() {
    this.loading = true;

    const formData = new FormData();
    formData.append(
      'ContractSettlementNumber',
      this.boobleModalData?.orderSettlement?.contractSettlementNumber
    );
    formData.append('ProofOperation', this.proofOperationFile);

    this.ordersService
      .seetlementConfirm(this.boobleModalData?.id, formData)
      .subscribe({
        next: () => {
          this.loading = false;
          this.closeModal();
          this.notifier.notify(
            'success',
            'Comprovante da operação enviado com sucesso!'
          );
          this.ordersService.updateOrderView();
        },
        error: (err) => {
          this.loading = false;
          console.error('Erro ao enviar comprovante:', err);
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
